import { render, staticRenderFns } from "./c_hotspot.vue?vue&type=template&id=51519a4a&scoped=true"
import script from "./c_hotspot.vue?vue&type=script&lang=js"
export * from "./c_hotspot.vue?vue&type=script&lang=js"
import style0 from "./c_hotspot.vue?vue&type=style&index=0&id=51519a4a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51519a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51519a4a')) {
      api.createRecord('51519a4a', component.options)
    } else {
      api.reload('51519a4a', component.options)
    }
    module.hot.accept("./c_hotspot.vue?vue&type=template&id=51519a4a&scoped=true", function () {
      api.rerender('51519a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_hotspot.vue"
export default component.exports